import React from 'react'
import { Header } from './Header'
import { User, LogOut } from 'lucide-react'
import { useAuthStore } from '../stores/authStore'
import { NotificationDropdown } from './NotificationDropdown'

interface LayoutProps {
  children: React.ReactNode
}

export function Layout({ children }: LayoutProps) {
  const { user, logout } = useAuthStore()

  return (
    <div className="flex h-screen layout-container">
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* User menu - moved to first position */}
        <div className="flex items-center space-x-3 pl-3 gradient-header" style={{ borderLeft: '1px solid rgba(255, 255, 255, 0.2)', paddingTop: '4px', paddingBottom: '4px' }}>
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 rounded-full flex items-center justify-center avatar-header">
              <User className="w-4 h-4 text-white" />
            </div>
            <span className="text-sm font-medium hidden md:block text-white">
              {user?.name || user?.username || 'Utilisateur'}
            </span>
          </div>
          
          <button
            onClick={logout}
            className="flex items-center space-x-2 px-3 py-2 text-sm font-medium rounded-lg transition-all button-header"
            title="Déconnexion"
          >
            <LogOut className="w-4 h-4" />
            <span className="hidden md:inline">Déconnexion</span>
          </button>

          {/* Notifications */}
          <NotificationDropdown />
        </div>
        <Header />
        <main className="flex-1 overflow-x-hidden overflow-y-auto p-6 gradient-main">
          <div className="max-w-6xl mx-auto w-full">
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}
